import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Dispatch } from "redux";
import EditAll from "./EditAll";
import { EditTposItemProps } from "@/app/types/line-items";
import { getAllProductsById } from "@/app/selectors/product";
import { userLineItems } from "@/app/selectors/lineItem";
import { getSelectedVariation } from "@/app/utils/variations";
import {
  copyOptions,
  deleteBasketAsync,
  deleteOptionLineAsync,
  updateAllOptionsAsync,
  updateOptionForLine,
} from "@/app/actions/options";
import {
  CopyOptionsAction,
  DeleteBasketAsyncAction,
  DeleteOptionLineAsyncAction,
  UpdateAllOptionsAsyncAction,
  UpdateOptionForLineAction,
} from "@/app/types/option";
import { withForwardRef } from "@/app/utils/withForwardRef";
import {
  getCurrentLineOptions,
  getOptionsByLine,
} from "@/app/selectors/options";
import { RootState } from "@/app/reducers";
import EditIndividual from "./EditIndividual";

const EditTposItem = (props: EditTposItemProps) => {
  const {
    lineItemId,
    onClose,
    customiseIndividual = false,
    setShowCustomiseIndividual,
    onUpdatePress,
  } = props;
  const dispatch =
    useDispatch<
      Dispatch<
        | UpdateAllOptionsAsyncAction
        | DeleteBasketAsyncAction
        | CopyOptionsAction
        | UpdateOptionForLineAction
        | DeleteOptionLineAsyncAction
      >
    >();
  const allProducts = useSelector(getAllProductsById);
  const currentLineOptions = useSelector((state: RootState) =>
    getCurrentLineOptions(state, props),
  );
  const selectedOptionsForLine = useSelector((state: RootState) =>
    getOptionsByLine(state, props),
  );

  const lineItems = useSelector(userLineItems);

  const lineItem = lineItems && lineItems.find((v) => `${v.id}` === lineItemId);
  const parentLineOptions = useSelector((state: RootState) =>
    getOptionsByLine(state, {
      lineItemId: lineItem?.parentId?.toString() ?? "",
    }),
  );
  const [quantity, setQuantity] = useState(lineItem?.quantity || 1);

  const product = allProducts && lineItem && allProducts[lineItem?.productId];

  useEffect(() => {
    let selectedOptions = product?.options || [];
    if (selectedOptionsForLine.length === 0) {
      if (parentLineOptions.length > 0) {
        selectedOptions = parentLineOptions;
      }
    } else {
      selectedOptions = selectedOptionsForLine;
    }
    dispatch(
      copyOptions({
        lineId: Number(lineItemId),
        options: selectedOptions,
      }),
    );
    dispatch(updateOptionForLine({ lineId: Number(lineItemId) }));
  }, []);

  if (!lineItem || !product) {
    return <></>;
  }

  const isRemoval = quantity === 0 && lineItem?.quantity > 0;
  const { variationItem } = getSelectedVariation([], product, allProducts);

  const deleteLine = () => {
    dispatch(deleteBasketAsync({ lineId: `${lineItem.id}` }));
    onClose();
  };

  const updateLine = () => {
    if (isRemoval) {
      deleteLine();
    }
    dispatch(
      updateAllOptionsAsync({
        lineId: String(lineItem.id),
        quantity,
        item: product,
      }),
    );
  };

  const onButtonPress = () => {
    updateLine();
    onUpdatePress();
  };

  return customiseIndividual ? (
    <EditAll
      lineItemId={lineItemId}
      variationItem={variationItem}
      currentLineOptions={currentLineOptions}
      onDeletePress={deleteLine}
      onQuantityChange={updateLine}
      onUpdateAllItemsPress={onButtonPress}
      setShowCustomiseIndividual={setShowCustomiseIndividual || (() => {})}
      quantity={quantity}
      setQuantity={setQuantity}
    />
  ) : (
    <EditIndividual
      lineItemId={lineItemId}
      variationItem={variationItem}
      currentLineOptions={currentLineOptions}
      onDeletePress={() => dispatch(deleteOptionLineAsync(lineItemId))}
    />
  );
};

export default withForwardRef<HTMLDivElement, EditTposItemProps>(EditTposItem);
